N<template>
  <v-container style="width: 100%;">
    <v-layout justify-space-between>
      <h1>Messagebird Number Masking</h1>
      <v-btn
        href="https://sumup.co.uk"
        target="_blank"
        color="green"
        dark
        class="text-none"
      >Go to SumUP</v-btn>
    </v-layout>
    <v-layout pt-3 justify-center v-if="config != null">
      <v-flex xs12 md8>
        <SimpleCard>
          <v-layout column>
            <h3>Messagebird Number Masking</h3>
            <v-checkbox
              single-line
              v-model="config.enabled"
              label="Enable Messagebird Number Masking (masked calls and texts will be charged at standard messagebird rates)"
            ></v-checkbox>
            <v-text-field
              type="number"
              v-model="config.expire_delay_minutes"
              min="0"
              step="1"
              class="small-label"
              label="Number of minutes to keep proxy open after trip completed (used in scenarious such as lost property phonecalls)"
            ></v-text-field>
            <v-flex pt-4>
              <h3>Leaving these fields blank will cause the number to either return caller busy, or messages to not be forwarded</h3>
            </v-flex>
            <v-text-field
              type="number"
              v-model="config.unknown_number_transfer"
              class="small-label"
              label="Default voice call transfer number if called from unrecognised number or number with no active booking mask"
            ></v-text-field>
            <v-text-field
              type="number"
              v-model="config.unknown_number_sms_forward"
              class="small-label"
              label="Default SMS forward number if messaged from unrecognised number or number with no active booking mask"
            ></v-text-field>
            <p>To ensure a good user experience, if disabled, existing masked numbers will continue to function, but no future bookings will have masked numbers</p>
            <v-flex pt-3>
              <v-btn @click="updateConfig" large class="text-none">Update number masking settings</v-btn>
            </v-flex>
          </v-layout>
        </SimpleCard>
      </v-flex>
    </v-layout>
    <v-layout pt-3 justify-center v-if="config.numbers != null">
      <v-flex xs12 md8>
        <SimpleCard>
          <v-layout column>
            <h3>Registered Proxy Numbers</h3>
            <v-flex pt-3>
              <ul>
                <li
                  style="list-style-type:disc;"
                  v-for="number in config.numbers"
                >{{ number.number }}</li>
              </ul>
            </v-flex>
          </v-layout>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";
import FixedCostList from "@/components/settings/pricing/FixedCostList.vue";
import SimpleCard from "@/components/widget/SimpleCard";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "fixed_pricing",
  components: {
    Overview,
    SimpleCard,
    FixedCostList
  },
  data: function() {
    return {
      config: null
    };
  },
  mounted: async function() {
    try {
      var url = `${this.$store.state.apiUrl}/settings/number_proxy/info`;

      let response = await axios.get(url, {
        params: {}
      });

      this.config = response.data;
    } catch (error) {
      this.loading = false;
      console.log("Failed to get history");
    }
  },
  methods: {
    success: function(data) {
      alert("Configuration Updated");
      this.errors = {};
    },
    failedWithError: function(error) {
      alert(error);
    },
    failed: function(data) {
      alert("Request Failed due to unknown error");
    },
    updateConfig: function() {
      var url = `${this.$store.state.apiUrl}/settings/number_proxy/update`;

      var completed = this.success;
      var failed = this.failed;
      var failedWithErrors = this.failedWithErrors;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(this.config),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            completed(res.data);
          } else {
            if (res.data.error) {
              failedWithError(res.data.error);
            } else {
              failed();
            }
          }
        })
        .catch(function(err) {
          failed("internal_server_error");
          console.error(err);
        });
    }
  }
};
</script>
